export default "__VITE_ASSET__8d07aff7__"